import Splide from '@splidejs/splide';

const EL = '.js-projects';
const ACTIVE_CLASS = 'is-active';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    fixedWidth: '530px',
    pagination: true,
    gap: 40,
    perMove: 1,
    speed: 200,
    breakpoints: {
      1024: {
        fixedWidth: '400px'
      },
      768: {
        fixedWidth: '100%',
        gap: 20,
        pagination: false
      }
    }
  }).mount();
}
